import { type ObjectValuesUnionType } from '../utils/typing';

export const NotificationRoutingBehaviors = Object.freeze({
  PUSH: 'PUSH',
  REPLACE: 'REPLACE',
});

export type NotificationRoutingBehavior = ObjectValuesUnionType<typeof NotificationRoutingBehaviors>;
